import PropTypes from "prop-types"
import React from "react"
import InvalidVariable from "./InvalidVariable"
import useVariableSelector from "./useVariableSelector"

export const VariableTreeShape = PropTypes.shape({
  [PropTypes.string]: PropTypes.shape({
    label: PropTypes.string,
    source: PropTypes.string,
    variables: PropTypes.object // recursive object shape
  })
})

/** Delimiter-scoped option groups: [{ delimiters: ["at"], variables }] */
export const VariableGroupsShape = PropTypes.arrayOf(
  PropTypes.shape({
    delimiters: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    ).isRequired,
    variables: VariableTreeShape.isRequired
  })
)

// Back-compat alias for the nested variables tree (group.variables).
export const VariableSelectorShape = VariableTreeShape

useVariableSelector.propTypes = {
  variables: VariableGroupsShape
}

const VariableSelector = ({
  variables,
  value,
  EmptyVariableSelectorList = InvalidVariable,
  createExecuteContext,
  children,
  ...passProps
}) => {
  const { selector, ...rest } = useVariableSelector({
    variables,
    value,
    EmptyVariableSelectorList,
    createExecuteContext
  })

  return (
    <React.Fragment>
      {selector}
      {children({
        ...passProps,
        ...rest
      })}
    </React.Fragment>
  )
}

VariableSelector.displayName = "VariableSelector"

export default VariableSelector
